import { deleted, updated } from 'constants/global/messages';
import type { Notification } from 'types/common/notification';

const deploymentRegionUpdateSuccess: Notification = {
  id: 'gamehosting/deployment/region/update/success',
  type: 'success',
  content: updated('region'),
};

const deploymentRegionUpdateError: Notification = {
  id: 'gamehosting/deployment/region/update/error',
  type: 'error',
  content: 'Region update failed.',
};

const deploymentRegionContainerDeleteSuccess: Notification = {
  id: 'gamehosting/deployment/region/container/delete/success',
  type: 'success',
  content: deleted('cloud group'),
};

const deploymentRegionContainerDeleteError: Notification = {
  id: 'gamehosting/deployment/region/container/delete/error',
  type: 'error',
  content: 'Cloud group deletion failed.',
};

const deploymentRegionContainerLocationDeleteSuccess: Notification = {
  id: 'gamehosting/deployment/region/container/location/delete/success',
  type: 'success',
  content: deleted('cloud location'),
};

const deploymentRegionContainerLocationDeleteError: Notification = {
  id: 'gamehosting/deployment/region/container/location/delete/error',
  type: 'error',
  content: 'Cloud location deletion failed.',
};

const NOTIFICATION_GAME_HOSTING = {
  deploymentRegionUpdateError,
  deploymentRegionUpdateSuccess,
  deploymentRegionContainerDeleteSuccess,
  deploymentRegionContainerDeleteError,
  deploymentRegionContainerLocationDeleteSuccess,
  deploymentRegionContainerLocationDeleteError,
};

export default NOTIFICATION_GAME_HOSTING;
